import data from '@emoji-mart/data'
import { Picker, init } from 'emoji-mart'

class EmojiUtils {
  static init() {
    window.registerPicker = ({
      ref,
      onEmojiSelect,
      locale,
      i18n,
      previewPosition,
      skinTonePosition,
      theme,
      emojiSize,
      custom
    }) =>
      new Picker({
        data: async () => {
          const response = await fetch('@space-core/utils/emoji/emoji-schema.json')

          return response.json()
        },
        ref,
        onEmojiSelect,
        i18n,
        locale,
        previewPosition,
        skinTonePosition,
        theme,
        emojiSize,
        custom
      })
  }

  static async initData() {
    init({ data })
  }

  static renderEmoji(code: string): string | null {
    try {
      const arrayCodeConverted = code.split('-')
      const arrayNumberCodes = arrayCodeConverted.map((code: string) => Number(code))

      return String.fromCodePoint(...arrayNumberCodes)
    } catch (error) {
      return null
    }
  }

  static convertUnifiedToNative(code: string): string {
    if (code?.includes('-')) {
      return `0x${code.replace(/-/g, '-0x')}-0xFE0F`
    }

    return `0x${code}-0xFE0F`
  }

  static getNativeFromUnified(code: string): string | null {
    try {
      return EmojiUtils.renderEmoji(EmojiUtils.convertUnifiedToNative(code))
    } catch (error) {
      return null
    }
  }
}

export default EmojiUtils
